import React, { ReactElement } from 'react';
import theme from './UserInfoRow.module.scss';
import { UserIcon } from '@/components/Icons';
import { useAsyncState, useGetProjectId } from '@/utils/hooks';
import { getUserDetails } from '@/services/projects';
// import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';

interface UserInfoRowLazyProps {
    userId: number;
    infoText?: ReactElement;
}

const UserInfoRowLazy: React.FC<UserInfoRowLazyProps> = ({ userId, infoText }) => {
    const projectId = useGetProjectId();
    const [userDetails] = useAsyncState(() => getUserDetails(projectId!, userId), [projectId, userId], null);

    return (
        <div className={theme.container}>
            {infoText && <span>{infoText}</span>}
            <UserIcon sizeInPx={28} userId={userId} />
            <div className={theme.text}>
                {userDetails?.displayName || ''}
                <span>{userDetails?.profileName || ''}</span>
            </div>
        </div>
    );
};

export default UserInfoRowLazy;
